import { Select } from 'antd'
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { ConfigCard } from './styles'
import { useDispatch, useSelector } from 'react-redux'
import { useQuery } from '@tanstack/react-query'
import { getCompanyTeams } from 'services/demands/teamsServices'
import { errorMessage } from 'services/messager'
import { updateTemplateTeam } from 'states/modules/editTemplate'

const SelectResponsibleTeam = ({ initialTeam }) => {
	const dispatch = useDispatch()

	const [selectedValue, setSelectedValue] = useState(initialTeam)

	const { data: teams, isLoading: isLoadingTeams } = useQuery({
		queryKey: ['team-options'],
		queryFn: fetchTeams,
		staleTime: 1000 * 30,
		refetchOnWindowFocus: false,
		retry: false,
	})

	async function fetchTeams() {
		try {
			const { list: teams } = await getCompanyTeams(1, 100)

			return teams
		} catch (error) {
			console.log(error)
			errorMessage({
				content: 'Erro ao carregar times',
			})
		}
	}

	const handleChangeTemplate = (value) => {
		setSelectedValue(value)
		dispatch(updateTemplateTeam(value))
	}

	const getSelectOptions = (options) => {
		if (!options) return <></>

		return (
			<>
				{options.map((option) => (
					<Select.Option key={option.id} value={option.id}>
						{option.name}
					</Select.Option>
				))}
			</>
		)
	}

	return (
		<ConfigCard title="Time responsável">
			<Select
				style={{ width: '100%' }}
				placeholder="Selecione o time responsável"
				value={!isLoadingTeams ? selectedValue : undefined}
				onChange={handleChangeTemplate}
				loading={isLoadingTeams}
				disabled={isLoadingTeams}>
				{!isLoadingTeams && getSelectOptions(teams)}
			</Select>
		</ConfigCard>
	)
}

SelectResponsibleTeam.propTypes = {
	initialTeam: PropTypes.string,
}

export default SelectResponsibleTeam
